import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedMessagingDataAccessMessagingModule } from '@fleetoperate/shared/messaging/data-access-messaging';

@NgModule({
  imports: [CommonModule, SharedMessagingDataAccessMessagingModule]
})
export class DeliveryShipperFeatureSettingsModule {}
